// CalendarLogic.js

export function getMonthDays(year, month) {
  // JS months are 0-based
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const days = [];
  const firstWeekDay = firstDay.getDay(); // 0 = Sunday

  // Adjust so Monday = 0
  const adjustedFirstDay = (firstWeekDay + 6) % 7;

  // Days from prev month
  for (let i = 0; i < adjustedFirstDay; i++) {
    const prevDate = new Date(year, month, -i);
    days.unshift({ 
      date: prevDate, 
      currentMonth: false 
    });
  }

  // Current month days
  for (let d = 1; d <= lastDay.getDate(); d++) {
    days.push({
      date: new Date(year, month, d),
      currentMonth: true
    });
  }

  // Fill up to full weeks
  while (days.length % 7 !== 0) {
    const nextDate = new Date(year, month, days.length - adjustedFirstDay + 1);
    days.push({
      date: nextDate,
      currentMonth: false
    });
  }

  return days;
}

export function getMonthName(monthIndex) {
  const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  return months[monthIndex];
}

export function getWeekDays() {
  return ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
}
